import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { Fragment, useState } from "react";
import { useRefresh, useNotify, useMutation, Button } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";

interface IActivateSchoolButton {
  schoolId: string;
}

const CustomConfirmButton = ({ schoolId }: IActivateSchoolButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleChangeStatusSchool, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `schools/${schoolId}/activate`,
      payload: {},
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully activate school.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed activate the school, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleChangeStatusSchool}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const ActivateSchoolButton = ({ schoolId }: IActivateSchoolButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
    table: {
      marginTop: "10px",
      minWidth: 650,
      padding: "1rem",
    },
  });

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button label={`Activate School`} onClick={handleOpenDialog} />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Activate The School</DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure you want to Activate the school?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <CustomConfirmButton schoolId={schoolId} />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ActivateSchoolButton;
